import BenchmarksPage from './benchmarks-page'

export default BenchmarksPage
